import { initializeNeuroApplication } from '@ignitesales/neuro-application';
import '@ignitesales/neuro-application/src/util/defaultLoginEmployee';
import WebFont from 'webfontloader';
import App from './App';
import AppLoading from './AppLoading';
import questionLayouts from './components/questions/containers/index.mjs';
import questionTypes from './components/questions/types/index.mjs';
import navigationReducer from './reducers/navigationReducer';
import initState from './utils/initState';
import messages from './i18n/messages';


const init = async () => {
  WebFont.load({
    typekit: {
      id: 'xdd8olc'
    }
  });

  await initializeNeuroApplication({
    AppComponent: App,
    LoadingComponent: AppLoading,
    messages,
    supportedLocales: ['en'],
    reducers: [navigationReducer],
    questionLayouts,
    questionTypes,
    decorateStateFn: async (state) => {
      return await initState(state);
    }
  });
};

init();
